module.exports = __webpack_public_path__ + "static/img/logo_product.ca0dde5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/logo_product.png
// module id = X4xR
// module chunks = 8